import { render, staticRenderFns } from "./MyShares.vue?vue&type=template&id=a680c5e6&scoped=true&"
import script from "./MyShares.vue?vue&type=script&lang=js&"
export * from "./MyShares.vue?vue&type=script&lang=js&"
import style0 from "./MyShares.vue?vue&type=style&index=0&id=a680c5e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680c5e6",
  null
  
)

export default component.exports